<template>
    <div>
        <index-header></index-header>
        <div class="com-container">
            <div class="ind-banner-container">
                <div class="ind-banner" id="J_Slide">
                    <ul id="J_IndBanner">
                        <li v-for="(item,index) in banner"
                         :key="index"
                         :style="renderLiTag(item,index)"
                         :class="`li${index}`">
                            <a class="link" :href="getLinkUrl(item)" :data-title="item.cTitle" :target="item.linkType == 1?'_blank':'_self'"></a>
                            <div class="info-bg"></div>
                            <div class="info">
                                <a class="title" :href="getLinkUrl(item)" :target="item.linkType == 1?'_blank':'_self'"><h4>{{item.title}}</h4></a>
                            </div>
                        </li>
                    </ul>
                    <strong id="J_IndBannerBtn">
                        <span v-for="(item,index) in banner" :key="index">
                            <span v-if="index==0" class="selected">{{index}}</span>
                            <span v-else>{{index}}</span>
                        </span>
                    </strong>
                </div>
                <div class="ind-recommend" style="background-image: url(//appimg1.3g.qq.com/msoft/android/a_zhuanti/m4-morning.png);">
                    <div class="con">
                        <h3 class="ofh">{{dayRcmd.title}}</h3>
                        <span class="ofh" style="color:rgb(255, 255, 255);">{{dayRcmd.content}}</span>
                    </div>
                    <div class="apk-info-bg"></div>
                    <div class="apk-info">
                        <div class="apk-info-con">
                            <!-- <a class="icon" :data-title="`${dayRcmd.appDetails[0].appName}`" :href="`${baseUrl}/detail.htm?apkName=${dayRcmd.appDetails[0].pkgName}&info=${dayRcmd.appDetails[0].apkMd5}`"><img :src="`${dayRcmd.appDetails[0].iconUrl}`"></a> -->
                            <a class="icon" :data-title="`${dayRcmd.appDetails[0].appName}`" href="https://a.app.qq.com/o/simple.jsp?pkgname=com.tencent.pao&g_f=1000047"><img :src="`${dayRcmd.appDetails[0].iconUrl}`"></a>
                            <!-- <a class="appName ofh" :href="`${baseUrl}/detail.htm?apkName=${dayRcmd.appDetails[0].pkgName}&info=${dayRcmd.appDetails[0].apkMd5}`">{{dayRcmd.appDetails[0].appName}}</a> -->
                            <a class="appName ofh" href="https://a.app.qq.com/o/simple.jsp?pkgname=com.tencent.pao&g_f=1000047">{{dayRcmd.appDetails[0].appName}}</a>
                            <com-ins-lit-btn :ex_url="dayRcmd.appDetails[0].apkUrl" :asistanturlid="comAsistanturlid"
                                :appname="dayRcmd.appDetails[0].appName" :apk="dayRcmd.appDetails[0].pkgName" :appicon="dayRcmd.appDetails[0].iconUrl">
                            </com-ins-lit-btn>
                        </div>
                    </div>
                </div>
                <div class="clear"></div>
            </div>

            <div class="ind-necessary-container">
                <div class="tit">装机必备</div>
                <div class="ind-necessary">
                    <a class="turn-left-btn unused" id="J_NecessaryTurnLeftBtn" href="javascript:void(0)"></a>
                    <div class="necessary-app-box" id="J_NecessaryAppBox">
                        <ul>
                            <li v-for="(item,index) in base" :key="index">
                                <com-vertical-app :item="item"/>
                            </li>
                        </ul>
                    </div>
                    <a class="turn-right-btn" id="J_NecessaryTurnRightBtn" href="javascript:void(0)"></a>
                    <div class="clear"></div>
                </div>
            </div>

            <div class="ind-appbody-container">
                <div class="ind-appbody-left">
                    <div class="ind-boutique">
                        <div class="ind-boutique-app">
                            <div class="tit">精品安卓游戏</div>
                            <div class="boutique-app-box">
                                <ul>
                                    <li v-for="(item,index) in hotGame" :key="index">
                                        <com-vertical-app :item="item" :type="item.categoryName"/>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="ind-boutique-game">
                            <div class="tit">精品安卓软件</div>
                            <div class="boutique-app-box">
                                <ul>
                                    <li v-for="(item,index) in hotApp" :key="index">
                                        <com-vertical-app :item="item" :type="item.categoryName"/>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <div class="ind-category">
                        <div class="category-tab-tit">
                            <ul class="clearfix" id="J_CategoryTabTit">
                                <span v-for="(cate,index) in catApps" :key="index">
                                    <li v-if="index == 0" class="cate1 selected"><span class="category1"><i :class="`i-id-${cate.cate_id}`"></i>{{cate.cate_name}}</span></li>
                                    <li v-else :class="`cate${index+1}`"><span :class="`category${index+1}`"><i :class="`i-id-${cate.cate_id}`"></i>{{cate.cate_name}}</span></li>
                                </span>

                                <!-- <li class="relax selected"><span></span>休闲益智</li>
                                <li class="fight"><span></span>对战策略</li>
                                <li class="chess"><span></span>棋牌休闲</li>
                                <li class="manage"><span></span>经营养成</li> -->
                            </ul>
                        </div>
                        <div class="category-tab-body">
                            <ul id="J_CategoryTabBody">
                                <span v-for="(item,index) in catApps" :key="index">
                                    <span v-if="index == 0">
                                        <li class="selected">
                                            <span v-for="(initItem,index) in item.appDetails" :key="index">
                                                <span v-if="index < 9">
                                                    <com-crosswise-app :item="initItem"/>
                                                </span>
                                            </span>
                                        </li>
                                    </span>
                                    <span v-else-if="index == 1">
                                        <li>
                                            <span v-for="(initItem,index) in item.appDetails" :key="index">
                                                <span v-if="index < 9">
                                                    <com-crosswise-app :item="initItem"/>
                                                </span>
                                            </span>
                                        </li>
                                    </span>
                                    <span v-else-if="index == 2">
                                        <li>
                                            <span v-for="(initItem,index) in item.appDetails" :key="index">
                                                <span v-if="index < 9">
                                                    <com-crosswise-app :item="initItem"/>
                                                </span>
                                            </span>
                                        </li>
                                    </span>
                                    <span v-else-if="index == 3">
                                        <li>
                                            <span v-for="(initItem,index) in item.appDetails" :key="index">
                                                <span v-if="index < 9">
                                                    <com-crosswise-app :item="initItem"/>
                                                </span>
                                            </span>
                                        </li>
                                    </span>
                                </span>
                            </ul>
                        </div>
                    </div>
                    <div class="ind-union">
                        <div class="union-tit">
                            <div class="tit">精选合集</div>
                        </div>
                        <div class="clear"></div>
                        <div class="union-left">
                            <div class="union-banner">
                                <!-- <a :href="`${baseUrl}/union.htm?unionId=${union[0].contextId}`" :style="`background-image: url(${union[0].picUrl});`"></a> -->
                                <a href="javascript:void()" :style="`background-image: url(${union[0].picUrl});`"></a>
                            </div>
                            <div class="union-app">
                                <ul>
                                    <li class="T_UnionHoverEvent" v-for="(item,index) in union[0].appDetails" :key="index">
                                        <com-vertical-lit-app  :item="item"/>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="union-right">
                            <div class="union-banner">
                                <!-- <a :href="`${baseUrl}/union.htm?unionId=${union[1].contextId}`" :style="`background-image: url(${union[1].picUrl});`"></a> -->
                                <a href="javascript:void()" :style="`background-image: url(${union[1].picUrl});`"></a>
                            </div>
                            <div class="union-app">
                                <li class="T_UnionHoverEvent" v-for="(item,index) in union[1].appDetails" :key="index">
                                    <com-vertical-lit-app  :item="item"/>
                                </li>
                            </div>
                        </div>
                        <div class="clear"></div>
                        <!-- <div class="union-more-banner">
                            <template v-for="(item,index) in union">
                                <div :key="index" v-if="index>1 && index<5" :class="`union-banner-cell ${index > 2 ? 'margin-cell' : ''}`" >
                                    <a :href="`${baseUrl}/union.htm?unionId=${item.contextId}`" :style="`background-image: url(${item.picUrl});`"></a>
                                </div>
                            </template>
                            <div class="clear"></div>
                        </div>
                        <div class="union-link-all">
                            <a :href="`${baseUrl}/union.htm?orgame=1&page=1`">
                                <span>更多应用合集</span>
                                <i class="arrow-right"></i>
                            </a>
                            <a class="more" :href="`${baseUrl}/union.htm?orgame=2&page=1`">
                                <span>更多游戏合集</span>
                                <i class="arrow-right"></i>
                            </a>
                            <div class="clear"></div>
                        </div> -->
                    </div>
                    <!-- <div class="ind-catelist">
                        <dl class="clearfix">
                            <dt>软件分类：</dt>
                            <dd v-for="(item,index) in cates[0]" :key="index"><a :href="`${baseUrl}/category.htm?orgame=1&categoryId=${item.cateId}`">{{item.cateName}}</a></dd>
                        </dl>
                        <dl class="clearfix">
                            <dt>游戏分类：</dt>
                            <dd v-for="(item,index) in cates[1]" :key="index"><a :href="`${baseUrl}/category.htm?orgame=2&categoryId=${item.cateId}`">{{item.cateName}}</a></dd>
                        </dl>
                    </div> -->
                </div>
                <div class="ind-appbody-right">
                    <div class="ind-week-rank">
                        <div class="rank-tit">
                            <div class="tit">
                                周下载排行
                            </div>
                            <ul class="rank-tab-btn" id="J_RankTabBtn">
                                <li class="selected"><a href="#">游戏</a></li>
                                <li><a href="#">应用</a></li>
                            </ul>
                            <div class="clear"></div>
                        </div>
                        <ul class="rank-tab-body" id="J_RankTabBody">
                            <li class="rank-tab-bind-body selected">
                                <ul class="rank-body T_RankBody">
                                    <com-list-app v-for="(item,index) in gameRank" :key="index" :item="item" :index="index"/>
                                </ul>
                            </li>
                            <li class="rank-tab-bind-body">
                                <ul class="rank-body T_RankBody">
                                    <com-list-app v-for="(item,index) in appRank" :key="index" :item="item" :index="index"/>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div class="ind-rank">
                        <div class="rank-tit">
                            <div class="tit">
                                动作游戏排行
                            </div>
                        </div>
                        <ul class="rank-body T_RankBody">
                            <com-list-app v-for="(item,index) in dzRank" :key="index" :item="item" :index="index"/>
                        </ul>
                    </div>
                    <div class="ind-rank">
                        <div class="rank-tit">
                            <div class="tit">
                                棋牌游戏排行
                            </div>
                        </div>
                        <ul class="rank-body T_RankBody">
                            <com-list-app v-for="(item,index) in qpRank" :key="index" :item="item" :index="index"/>
                        </ul>
                    </div>
                    <div class="ind-rank">
                        <div class="rank-tit">
                            <div class="tit">
                                社交软件排行
                            </div>
                        </div>
                        <ul class="rank-body T_RankBody">
                            <com-list-app v-for="(item,index) in sjRank" :key="index" :item="item" :index="index"/>
                        </ul>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </div>
        <footer-common :imgRand="imgRand" :assets="assets" :source="source"></footer-common>
        <div class="return-top">
            <div id="return" class="com-return">
                <a href="javascript:void(0);"></a>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../components/header.vue';
import { dynamicLoadCss, sourceMap, onlineMap, baseUrl } from '../utils/tools';
import ComInsLitBtn from '../components/com-ins-lit-btn.vue';
import ComVerticalApp from './macro/com-vertical-app.vue';
import ComListApp from './macro/com-list-app.vue';
import FooterCommon from '../components/footer-common.vue';
import ComVerticalLitApp from './macro/com-vertical-lit-app.vue';
import ComCrosswiseApp from './macro/com-crosswise-app.vue';
export default {
  name: 'index',
  components: {
    'index-header': Header,
    'com-ins-lit-btn': ComInsLitBtn,
    'com-vertical-app': ComVerticalApp,
    'com-list-app': ComListApp,
    'footer-common': FooterCommon,
    'com-vertical-lit-app': ComVerticalLitApp,
    'com-crosswise-app': ComCrosswiseApp
  },
  data () {
    return {
      menu: 'index',
      pageNameTj: 'index',
      pageJsSrc: 'app/page/index',
      banner: [
        {
          cTitle: '',
          title: '国家反诈中心',
          toUrl: '',
          picUrl: 'https://download.sj.qq.com/upload/2021/03/17/77e3b745d3c56c80e6f427e95e1064d5.jpg',
          adType: 1,
          contextId: 0,
          linkType: '_self',
          appDetails: [
            {
              apkMd5: '735444CDC0CDBABE40BF36BFF94D9634',
              appName: 'com.hicorenational.antifraud'
            }

          ],
          pkgNames: ['com.hicorenational.antifraud']

        }
        // {
        //   cTitle: '',
        //   title: '附近美女互动交友直播',
        //   toUrl: '',
        //   contextId: 1,
        //   picUrl: 'https://download.sj.qq.com/upload/2019/08/30/a86ab288dc22c76cea6000942c631693.jpg',
        //   adType: 1,
        //   linkType: '_self',
        //   appDetails: [
        //     {
        //       apkMd5: '9D923B8C8B61395170E8B7E5E0B19D6E',
        //       appName: 'com.tencent.now'
        //     }

        //   ],
        //   pkgNames: ['com.tencent.now']
        // },
        // {
        //   cTitle: '',
        //   title: '轩辕传奇',
        //   toUrl: '',
        //   picUrl: 'https://download.sj.qq.com/upload/2020/11/03/7949fa6f639f607ee3fc850c04c357c3.jpg',
        //   adType: 1,
        //   contextId: 2,
        //   linkType: '_self',
        //   appDetails: [
        //     {
        //       apkMd5: '',
        //       appName: 'com.tencent.tmgp.xymobile'
        //     }
        //   ],
        //   pkgNames: ['com.tencent.tmgp.xymobile']
        // },
        // {
        //   cTitle: '',
        //   title: 'QQ炫舞手游',
        //   toUrl: '',
        //   picUrl: 'https://download.sj.qq.com/upload/2020/11/03/5b2e8801896b38e15ee7fe684793fb5d.jpg',
        //   adType: 1,
        //   contextId: 3,
        //   linkType: '_self',
        //   appDetails: [
        //     {
        //       apkMd5: '5EC0B54662EBC68F865DD8264029E320',
        //       appName: 'com.tencent.tmgp.qqx5'
        //     }
        //   ],
        //   pkgNames: ['com.tencent.tmgp.qqx5']
        // }
      ],
      dayRcmd: {
        title: '全球最多人玩的跑酷游戏',
        content: '一路跑酷，与你为伍！',
        appDetails: [
          {
            appName: '天天酷跑',
            iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10099632_1636722965/256',
            pkgName: 'com.tencent.pao',
            apkMd5: '8A2608C3313FE98E2C18482BB325D761',
            apkUrl: 'https://imtt.dd.qq.com/16891/apk/E0C7692C7264EBC38AA4F2B9FC5BAF11.apk?fsname=ctrip.android.view_8.42.0_1449.apk&csr=9dcc'
          }
        ]
      },
      appName: '',
      comAsistanturlid: '990499',
      gameRank: [
        {
          appName: '天天酷跑',
          apkMd5: '8A2608C3313FE98E2C18482BB325D761',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/8A2608C3313FE98E2C18482BB325D761.apk?fsname=com.tencent.pao_9300.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10099632_1636722965/96',
          pkgName: 'com.tencent.pao',
          appDownCount: '9.1亿'
        },
        {
          appName: '王者荣耀',
          apkMd5: '607E2D024EA7186CD5AF14AA032013A0',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/607E2D024EA7186CD5AF14AA032013A0.apk?fsname=com.tencent.tmgp.sgame_371010800.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_12127266_1634801224/96',
          pkgName: 'com.tencent.tmgp.sgame',
          appDownCount: '12亿'
        },
        {
          appName: '欢乐斗地主（腾讯）',
          apkMd5: '38CC9EDFBFD153907B24E8E4506A63D9',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/38CC9EDFBFD153907B24E8E4506A63D9.apk?fsname=com.qqgame.hlddz_233.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_97949_1635488365/96',
          pkgName: 'com.qqgame.hlddz',
          appDownCount: '8.4亿'
        },
        {
          appName: '穿越火线-枪战王者（国民枪战手游）',
          apkMd5: 'AAE7C5BE6DFE14725A835D62C6F104EE',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/AAE7C5BE6DFE14725A835D62C6F104EE.apk?fsname=com.tencent.tmgp.cf_500.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_12165022_1634801217/96',
          pkgName: 'com.tencent.tmgp.cf',
          appDownCount: '2.8亿'
        }
        // {
        //   appName: '天天飞车',
        //   apkMd5: 'BDD2DF5865BC9A01E03C1A1DB8EE3162',
        //   apkUrl: 'https://imtt.dd.qq.com/16891/apk/BDD2DF5865BC9A01E03C1A1DB8EE3162.apk?fsname=com.tencent.game.SSGame_3.6.4.709_464709.apk&csr=9dcc',
        //   iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10307710_1567062710/96',
        //   pkgName: 'com.tencent.game.SSGame',
        //   appDownCount: '2.4亿'
        // }
      ],
      appRank: [
        {
          appName: 'QQ',
          apkMd5: 'D649375F16C0B8CEC06AE6EFC61DF43E',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/D649375F16C0B8CEC06AE6EFC61DF43E.apk?fsname=com.tencent.mobileqq_8.8.50_2324.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_6633_1637143651/96',
          pkgName: 'com.tencent.mobileqq',
          appDownCount: '95亿'
        },
        {
          appName: '腾讯手机管家—QQ微信保护',
          apkMd5: '13ACA260DD0281293B8E776B814AC03C',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/13ACA260DD0281293B8E776B814AC03C.apk?fsname=com.tencent.qqpimsecure_15.1.0_1430.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_5284_1635432758/96',
          pkgName: 'com.tencent.qqpimsecure',
          appDownCount: '37亿'
        },
        {
          appName: '微信',
          apkMd5: 'ECBC26B82A88E949BCBBA59A9D3FC30D',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/ECBC26B82A88E949BCBBA59A9D3FC30D.apk?fsname=com.tencent.mm_8.0.16_2040.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10910_1635498550/96',
          pkgName: 'com.tencent.mm',
          appDownCount: '88亿'
        },
        {
          appName: '爱奇艺',
          apkMd5: '5BFDDFD468EF820195B5CD9B52A90F57',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/5BFDDFD468EF820195B5CD9B52A90F57.apk?fsname=com.qiyi.video_12.11.0_800121150.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_7720_1636362705/96',
          pkgName: 'com.qiyi.video',
          appDownCount: '27亿'
        },
        {
          appName: 'WiFi万能钥匙',
          apkMd5: 'B3C53E85B777DC8AA805EEEE5013CB24',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/B3C53E85B777DC8AA805EEEE5013CB24.apk?fsname=com.snda.wifilocating_4.8.05_211110.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_93301_1636540149/96',
          pkgName: 'com.snda.wifilocating',
          appDownCount: '87亿'
        }
      ],
      dzRank: [
        {
          appName: '星界幻想',
          apkMd5: '5990A99938F357B030C1FA432D102355',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/5990A99938F357B030C1FA432D102355.apk?fsname=com.tencent.tmgp.lzzq_lzzq_4.2_30.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_53886918_1630984016/96',
          pkgName: 'com.tencent.tmgp.lzzq_lzzq',
          appDownCount: '3.6万'
        },
        {
          appName: '天天炫斗',
          apkMd5: 'EDA963D244C26FD306E0B5D22DDCE18A',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/EDA963D244C26FD306E0B5D22DDCE18A.apk?fsname=com.tencent.game.VXDGame_47000904.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10451659_1627026640/96',
          pkgName: 'com.tencent.game.VXDGame',
          appDownCount: '1.1亿'
        },
        {
          appName: '地铁跑酷（世界环游）',
          apkMd5: '8166149BE608710A70B83C44E6F84285',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/8166149BE608710A70B83C44E6F84285.apk?fsname=com.kiloo.subwaysurf_3.25.0_32500.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_273948_1634799608/96',
          pkgName: 'com.kiloo.subwaysurf',
          appDownCount: '1.5亿'
        },
        {
          appName: '三国之刃',
          apkMd5: '64F864B0E7B4A8C4C306EAC18E292C12',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/64F864B0E7B4A8C4C306EAC18E292C12.apk?fsname=com.tencent.tmgp.sgzr_110.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10681702_1635300080/96',
          pkgName: 'com.tencent.tmgp.sgzr',
          appDownCount: '1305万'
        },
        {
          appName: '神庙逃亡2（送红包）',
          apkMd5: '3DEC52FE61E8B6564ACAF4861CEE1885',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/3DEC52FE61E8B6564ACAF4861CEE1885.apk?fsname=com.imangi.templerun2_5.20.0_52000.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_1144294_1635473836/96',
          pkgName: 'com.imangi.templerun2',
          appDownCount: '1.5亿'
        }
      ],
      qpRank: [
        {
          appName: '欢乐斗地主（腾讯）',
          apkMd5: '38CC9EDFBFD153907B24E8E4506A63D9',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/38CC9EDFBFD153907B24E8E4506A63D9.apk?fsname=com.qqgame.hlddz_233.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_97949_1635488365/96',
          pkgName: 'com.qqgame.hlddz',
          appDownCount: '8.4亿'
        },
        {
          appName: '腾讯欢乐麻将全集',
          apkMd5: '7B65B6DA800A7A47882AB024B626F05D',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/7B65B6DA800A7A47882AB024B626F05D.apk?fsname=com.qqgame.happymj_76950.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10125368_1634807489/96',
          pkgName: 'com.qqgame.happymj',
          appDownCount: '3.2亿'
        },
        {
          appName: '天天象棋',
          apkMd5: 'D5685884B7E7B9812336C2DD458D3B88',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/D5685884B7E7B9812336C2DD458D3B88.apk?fsname=com.tencent.qqgame.xq_41102.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_4504_1635751079/96',
          pkgName: 'com.tencent.qqgame.xq',
          appDownCount: '1.1亿'
        },
        // {
        //   appName: '天天德州',
        //   apkMd5: '3F732267424961A596224BDA7EE58FBB',
        //   apkUrl: 'https://imtt.dd.qq.com/16891/3F732267424961A596224BDA7EE58FBB.apk?fsname=com.tencent.qqgame.qqTexaswvga_7.4.0.4_740004.apk&csr=9dcc',
        //   iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_1115588_1535969743/96',
        //   pkgName: 'com.tencent.qqgame.qqTexaswvga',
        //   appDownCount: '3235万'
        // },
        {
          appName: '欢乐升级（腾讯）',
          apkMd5: '943E6FAD43E8AED990A91A37C2E7A8A9',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/943E6FAD43E8AED990A91A37C2E7A8A9.apk?fsname=com.tencent.qqgame.qqhlupwvga_39860.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10103101_1635496791/96',
          pkgName: 'com.tencent.qqgame.qqhlupwvga',
          appDownCount: '2631万'
        }
      ],
      sjRank: [
        {
          appName: 'QQ',
          apkMd5: 'D649375F16C0B8CEC06AE6EFC61DF43E',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/D649375F16C0B8CEC06AE6EFC61DF43E.apk?fsname=com.tencent.mobileqq_8.8.50_2324.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_6633_1637143651/96',
          pkgName: 'com.tencent.mobileqq',
          appDownCount: '95亿'
        },
        {
          appName: '微信',
          apkMd5: 'ECBC26B82A88E949BCBBA59A9D3FC30D',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/ECBC26B82A88E949BCBBA59A9D3FC30D.apk?fsname=com.tencent.mm_8.0.16_2040.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10910_1635498550/96',
          pkgName: 'com.tencent.mm',
          appDownCount: '88亿'
        },
        {
          appName: 'QQ空间',
          apkMd5: '66622D0D4EA7529E929E15E20639D918',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/66622D0D4EA7529E929E15E20639D918.apk?fsname=com.qzone_8.8.0.288_137.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_9959_1636980723/96',
          pkgName: 'com.qzone',
          appDownCount: '15亿'
        },
        {
          appName: 'MOMO陌陌',
          apkMd5: 'D8478038CEFAD94669243155E9FD9988',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/D8478038CEFAD94669243155E9FD9988.apk?fsname=com.immomo.momo_9.1.4_8035.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_11381_1637052068/96',
          pkgName: 'com.immomo.momo',
          appDownCount: '6.4亿'
        },
        {
          appName: '探探',
          apkMd5: '9FC4B8815B0D293CEF865F71EE8A2D63',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/9FC4B8815B0D293CEF865F71EE8A2D63.apk?fsname=com.p1.mobile.putong_4.9.7.1_2497110.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10604320_1637118008/96',
          pkgName: 'com.p1.mobile.putong',
          appDownCount: '1.6亿'
        }
      ],
      hotApp: [
        {
          appName: 'QQ',
          apkMd5: 'D649375F16C0B8CEC06AE6EFC61DF43E',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/D649375F16C0B8CEC06AE6EFC61DF43E.apk?fsname=com.tencent.mobileqq_8.8.50_2324.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_6633_1637143651/96',
          pkgName: 'com.tencent.mobileqq',
          categoryName: '社交'
        },
        {
          appName: '微信',
          apkMd5: 'ECBC26B82A88E949BCBBA59A9D3FC30D',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/ECBC26B82A88E949BCBBA59A9D3FC30D.apk?fsname=com.tencent.mm_8.0.16_2040.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10910_1635498550/96',
          pkgName: 'com.tencent.mm',
          categoryName: '社交'
        },
        {
          appName: 'QQ浏览器-看热点资讯读免费小说',
          apkMd5: 'EDC88F229E92132CD381E5D3D9C693DC',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/EDC88F229E92132CD381E5D3D9C693DC.apk?fsname=com.tencent.mtt_12.1.5.5044_12155500.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_11384_1636972455/96',
          pkgName: 'com.tencent.mtt',
          categoryName: '工具'
        },
        {
          appName: '腾讯手机管家—QQ微信保护',
          apkMd5: '13ACA260DD0281293B8E776B814AC03C',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/13ACA260DD0281293B8E776B814AC03C.apk?fsname=com.tencent.qqpimsecure_15.1.0_1430.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_5284_1635432758/96',
          pkgName: 'com.tencent.qqpimsecure',
          categoryName: '系统'
        },
        {
          appName: 'QQ音乐',
          apkMd5: '963911FFA85921F9D64B5D25E16F5957',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/963911FFA85921F9D64B5D25E16F5957.apk?fsname=com.tencent.qqmusic_11.0.1.6_2520.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_6259_1636374590/96',
          pkgName: 'com.tencent.qqmusic',
          categoryName: '音乐'
        },
        {
          appName: '搜狗输入法',
          apkMd5: 'F98C3D065361FEB10D156CCED6120733',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/F98C3D065361FEB10D156CCED6120733.apk?fsname=com.sohu.inputmethod.sogou_10.36.1_1541.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_6866_1637047319/96',
          pkgName: 'com.sohu.inputmethod.sogou',
          categoryName: '工具'
        },
        {
          appName: '腾讯新闻-打开眼界',
          apkMd5: 'FC1B3E0404879FF8F8657357379B9293',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/FC1B3E0404879FF8F8657357379B9293.apk?fsname=com.tencent.news_6.6.70_6670.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_5613_1636451568/96',
          pkgName: 'com.tencent.news',
          categoryName: '阅读'
        },
        {
          appName: 'QQ空间',
          apkMd5: '66622D0D4EA7529E929E15E20639D918',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/66622D0D4EA7529E929E15E20639D918.apk?fsname=com.qzone_8.8.0.288_137.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_9959_1636980723/96',
          pkgName: 'com.qzone',
          categoryName: '社交'
        }
      ],
      hotGame: [
        {
          appName: '金铲铲之战',
          apkMd5: '159A706D15F8CDD00AE69A707E2F3D4F',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/159A706D15F8CDD00AE69A707E2F3D4F.apk?fsname=com.tencent.jkchess_674.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_54152245_1636475778/96',
          pkgName: 'com.tencent.jkchess',
          categoryName: '经营策略'
        },
        {
          appName: '光与夜之恋',
          apkMd5: 'FEDC057F47947082863046EDE37520F0',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/FEDC057F47947082863046EDE37520F0.apk?fsname=com.tencent.tmgp.lv_10.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_53991553_1633003623/96',
          pkgName: 'com.tencent.tmgp.lv',
          categoryName: '经营策略'
        },
        {
          appName: '妄想山海',
          apkMd5: '095A972517AA5B06011BF313839D616C',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/095A972517AA5B06011BF313839D616C.apk?fsname=com.tencent.tmgp.djsy_400201.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_12160554_1634611969/96',
          pkgName: 'com.tencent.tmgp.djsy',
          categoryName: '角色扮演'
        },
        {
          appName: '乱世王者-天美出品SLG王者手游',
          apkMd5: 'A9E2D8FB43FD9FCCB7F7156538A2B90A',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/A9E2D8FB43FD9FCCB7F7156538A2B90A.apk?fsname=com.tencent.tmgp.wec_1009038.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_42359119_1635993229/96',
          pkgName: 'com.tencent.tmgp.wec',
          categoryName: '网络游戏'
        },
        // {
        //   appName: '黎明觉醒',
        //   apkMd5: 'CC210B98F8BA589B381C634A2294BBE0',
        //   apkUrl: 'httpss://dlied5.myapp.com/myapp/1108179104/cos.release-77752/89900012_com.tencent.toaa_a917161_1.0_j42pzn.apk&csr=9dcc',
        //   iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_52860150_1599012747/96',
        //   pkgName: 'com.tencent.toaa',
        //   categoryName: '角色扮演'
        // },
        {
          appName: '荣耀新三国',
          apkMd5: '3E7AA513FE946B49B9B92E5CB4615192',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/3E7AA513FE946B49B9B92E5CB4615192.apk?fsname=com.tencent.ryxsg_10025161.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_54057295_1636425533/96',
          pkgName: 'com.tencent.ryxsg',
          categoryName: '经营策略'
        },
        {
          appName: '僵尸前线3',
          apkMd5: '68CB44EFD8CFB996A0F2C5A43F81E0BB',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/68CB44EFD8CFB996A0F2C5A43F81E0BB.apk?fsname=com.feelingtouch.strikeforce_9.9.1_991.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_96387_1453694101/96',
          pkgName: 'com.feelingtouch.strikeforce',
          categoryName: '飞行射击'
        },
        {
          appName: '密室逃亡',
          apkMd5: '71661DE83D04BBF0467100E08F227C99',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/71661DE83D04BBF0467100E08F227C99.apk?fsname=com.escape.feixiang_2.3.2_132.apk&csr=9dcc',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10070525_1555680205/96',
          pkgName: 'com.escape.feixiang',
          categoryName: '动作冒险'
        }
      ],
      catApps: [
        {
          cate_id: '0',
          cate_name: '角色扮演',
          appDetails: [
            {
              apkMd5: 'D52A62E360000439F80E53B069BD6450',
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/D52A62E360000439F80E53B069BD6450.apk?fsname=com.tencent.dianhun.wdxk_1000475.apk&csr=9dcc',
              appName: '我的侠客',
              pkgName: 'com.tencent.dianhun.wdxk',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_53921981_1635382982/96',
              appDownCount: '5.8万'
            },
            {
              apkMd5: '8A2608C3313FE98E2C18482BB325D761',
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/8A2608C3313FE98E2C18482BB325D761.apk?fsname=com.tencent.pao_9300.apk&csr=9dcc',
              appName: '天天酷跑',
              pkgName: 'com.tencent.pao',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10099632_1636722965/96',
              appDownCount: '9.1亿'
            },
            {
              apkMd5: '607E2D024EA7186CD5AF14AA032013A0',
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/607E2D024EA7186CD5AF14AA032013A0.apk?fsname=com.tencent.tmgp.sgame_371010800.apk&csr=9dcc',
              appName: '王者荣耀',
              pkgName: 'com.tencent.tmgp.sgame',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_12127266_1634801224/96',
              appDownCount: '12亿'
            },
            {
              apkMd5: '38CC9EDFBFD153907B24E8E4506A63D9',
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/38CC9EDFBFD153907B24E8E4506A63D9.apk?fsname=com.qqgame.hlddz_233.apk&csr=9dcc',
              appName: '欢乐斗地主（腾讯）',
              pkgName: 'com.qqgame.hlddz',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_97949_1635488365/96',
              appDownCount: '8.4亿'
            },
            {
              apkMd5: '3DBAB5ADBA570F458450A75379550047',
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/3DBAB5ADBA570F458450A75379550047.apk?fsname=com.tencent.peng_2003002.apk&csr=9dcc',
              appName: '天天爱消除（万家团圆版）',
              pkgName: 'com.tencent.peng',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10098215_1635924864/96',
              appDownCount: '2.7亿'
            },
            // {
            //   apkMd5: 'BDD2DF5865BC9A01E03C1A1DB8EE3162',
            //   apkUrl: 'https://imtt.dd.qq.com/16891/apk/BDD2DF5865BC9A01E03C1A1DB8EE3162.apk?fsname=com.tencent.game.SSGame_3.6.4.709_464709.apk&csr=9dcc',
            //   appName: '天天飞车',
            //   pkgName: 'com.tencent.game.SSGame',
            //   iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10307710_1567062710/96',
            //   appDownCount: '2.4亿'
            // },
            {
              apkMd5: '7B65B6DA800A7A47882AB024B626F05D',
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/7B65B6DA800A7A47882AB024B626F05D.apk?fsname=com.qqgame.happymj_76950.apk&csr=9dcc',
              appName: '腾讯欢乐麻将全集',
              pkgName: 'com.qqgame.happymj',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10125368_1634807489/96',
              appDownCount: '3.2亿'
            },
            {
              apkMd5: 'AAE7C5BE6DFE14725A835D62C6F104EE',
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/AAE7C5BE6DFE14725A835D62C6F104EE.apk?fsname=com.tencent.tmgp.cf_500.apk&csr=9dcc',
              appName: '穿越火线-枪战王者（国民枪战手游）',
              pkgName: 'com.tencent.tmgp.cf',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_12165022_1634801217/96',
              appDownCount: '2.8亿'
            }
            // {
            //   apkMd5: '018E0BA8E93AAEE768992ED31034A260',
            //   apkUrl: 'https://imtt.dd.qq.com/16891/apk/018E0BA8E93AAEE768992ED31034A260.apk?fsname=com.tencent.clover_110900.apk&csr=9dcc',
            //   appName: '雷霆战机-- 超人气飞行射击类手游',
            //   pkgName: 'com.tencent.clover',
            //   iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10453026_1628678901/96',
            //   appDownCount: '1.9亿'
            // }
          ]
        }
        // {
        //   cate_id: '107',
        //   cate_name: '工具',
        //   appDetails: [
        //     {
        //       apkMd5: '7694BF3FE1F1901A72FB66EA8B3646BA',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/7694BF3FE1F1901A72FB66EA8B3646BA.apk?fsname=com.moji.mjweather_9.0200.02_9020002.apk&csr=9dcc',
        //       appName: '墨迹天气',
        //       pkgName: 'com.moji.mjweather',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_9206_1637043683/96',
        //       appDownCount: '\t\t下载10亿次\n\t'
        //     },
        //     {
        //       apkMd5: '94D1A669CAF324CAC31149500FF3FE9C',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/94D1A669CAF324CAC31149500FF3FE9C.apk?fsname=com.icoolme.android.weather_7.1.2_2052000058.apk&csr=9dcc',
        //       appName: '最美天气',
        //       pkgName: 'com.icoolme.android.weather',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_11479_1636122141/96',
        //       appDownCount: '\t\t下载5.9亿次\n\t'
        //     },
        //     {
        //       apkMd5: '8C9219CE5BBAD997CD4DAFE1B06C8939',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/8C9219CE5BBAD997CD4DAFE1B06C8939.apk?fsname=com.sdu.didi.psnger_6.2.4_2143.apk&csr=9dcc',
        //       appName: '滴滴出行',
        //       pkgName: 'com.sdu.didi.psnger',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_288717_1624514350/96',
        //       appDownCount: '\t\t下载5.2亿次\n\t'
        //     },
        //     {
        //       apkMd5: 'D9ECA644D804735970C402B527312A1C',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/D9ECA644D804735970C402B527312A1C.apk?fsname=com.wuba_10.23.2_102302.apk&csr=9dcc',
        //       appName: '58同城-招聘找工作找家政',
        //       pkgName: 'com.wuba',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_6512_1636970863/96',
        //       appDownCount: '\t\t下载4.9亿次\n\t'
        //     },
        //     {
        //       apkMd5: '1F4A5D9B13F051E1F7F8B1D1FFA3B131',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/1F4A5D9B13F051E1F7F8B1D1FFA3B131.apk?fsname=com.when.coco_7.5.0_8115.apk&csr=9dcc',
        //       appName: '365日历万年历农历',
        //       pkgName: 'com.when.coco',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_1278445_1634093019/96',
        //       appDownCount: '\t\t下载5112万次\n\t'
        //     },
        //     {
        //       apkMd5: '5F3F10E3C3EA06F0FADF977ABE6414A8',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/5F3F10E3C3EA06F0FADF977ABE6414A8.apk?fsname=com.dianping.v1_10.53.3_105301.apk&csr=9dcc',
        //       appName: '大众点评',
        //       pkgName: 'com.dianping.v1',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_7960_1637050565/96',
        //       appDownCount: '\t\t下载3.7亿次\n\t'
        //     },
        //     {
        //       apkMd5: '697DE478BEC426ACB248198C066808C6',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/697DE478BEC426ACB248198C066808C6.apk?fsname=me.ele_10.3.6_756.apk&csr=9dcc',
        //       appName: '饿了么',
        //       pkgName: 'me.ele',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_1029694_1634547092/96',
        //       appDownCount: '\t\t下载2.0亿次\n\t'
        //     },
        //     {
        //       apkMd5: '4A184FE20CE0F8971642E1F3FD2DB914',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/4A184FE20CE0F8971642E1F3FD2DB914.apk?fsname=com.sinovatech.unicom.ui_8.9.2_123.apk&csr=9dcc',
        //       appName: '中国联通',
        //       pkgName: 'com.sinovatech.unicom.ui',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_3722_1637135156/96',
        //       appDownCount: '\t\t下载2.5亿次\n\t'
        //     },
        //     {
        //       apkMd5: 'A15BE2181FE6963F9665E872F330B30B',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/A15BE2181FE6963F9665E872F330B30B.apk?fsname=com.nuomi_8.7.5_464.apk&csr=9dcc',
        //       appName: '百度糯米',
        //       pkgName: 'com.nuomi',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_8833_1634092889/96',
        //       appDownCount: '\t\t下载1.0亿次\n\t'
        //     }
        //   ]
        // },
        // {
        //   cate_id: '114',
        //   cate_name: '理财',
        //   appDetails: [
        //     {
        //       apkMd5: '6B116DE0F23357D31B9E508AC69CFFEF',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/6B116DE0F23357D31B9E508AC69CFFEF.apk?fsname=com.yirendai_6.3.9_1737.apk&csr=9dcc',
        //       appName: '宜人贷借款',
        //       pkgName: 'com.yirendai',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10195838_1636441418/96',
        //       appDownCount: '\t\t下载7703万次\n\t'
        //     },
        //     {
        //       apkMd5: 'F35143EEAD27BCD03F2C24AD68CE4792',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/F35143EEAD27BCD03F2C24AD68CE4792.apk?fsname=com.android.dazhihui_9.43_142478.apk&csr=9dcc',
        //       appName: '大智慧',
        //       pkgName: 'com.android.dazhihui',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_12101_1636451062/96',
        //       appDownCount: '\t\t下载5001万次\n\t'
        //     },
        //     {
        //       apkMd5: '3D0F844291A626C2B36B050BABC3DE06',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/3D0F844291A626C2B36B050BABC3DE06.apk?fsname=com.chinamworld.main_5.6.1_817.apk&csr=9dcc',
        //       appName: '中国建设银行',
        //       pkgName: 'com.chinamworld.main',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10647_1636566295/96',
        //       appDownCount: '\t\t下载3.8亿次\n\t'
        //     },
        //     {
        //       apkMd5: 'CA40DE5E8269B2FF20ABB106D36CAB15',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/CA40DE5E8269B2FF20ABB106D36CAB15.apk?fsname=com.hexin.plat.android_10.40.10_4635.apk&csr=9dcc',
        //       appName: '同花顺手机炒股股票软件',
        //       pkgName: 'com.hexin.plat.android',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_6754_1636532586/96',
        //       appDownCount: '\t\t下载1.4亿次\n\t'
        //     },
        //     {
        //       apkMd5: '5066598863D92827D70201B485239F81',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/5066598863D92827D70201B485239F81.apk?fsname=com.mymoney_12.93.4.0_12093040.apk&csr=9dcc',
        //       appName: '随手记',
        //       pkgName: 'com.mymoney',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10527_1637035241/96',
        //       appDownCount: '\t\t下载8741万次\n\t'
        //     },
        //     {
        //       apkMd5: '4F0C361AEB24E1FEF28C6033EC0EFA23',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/4F0C361AEB24E1FEF28C6033EC0EFA23.apk?fsname=com.pingan.lifeinsurance_7.11.02_71102.apk&csr=9dcc',
        //       appName: '平安金管家',
        //       pkgName: 'com.pingan.lifeinsurance',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_1235317_1636945689/96',
        //       appDownCount: '\t\t下载2.2亿次\n\t'
        //     },
        //     {
        //       apkMd5: '7DB17D983B508D81293D9B75B4DC7E86',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/7DB17D983B508D81293D9B75B4DC7E86.apk?fsname=com.chinatelecom.bestpayclient_10.11.31_101131.apk&csr=9dcc',
        //       appName: '翼支付',
        //       pkgName: 'com.chinatelecom.bestpayclient',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_5261_1636706623/96',
        //       appDownCount: '\t\t下载1.4亿次\n\t'
        //     }
        //   ]
        // },
        // {
        //   cate_id: '106',
        //   cate_name: '社交',
        //   appDetails: [
        //     {
        //       apkMd5: 'D2510450258BBA98E67CA99B44443A7B',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/D2510450258BBA98E67CA99B44443A7B.apk?fsname=com.tencent.mobileqq_8.8.50_2324.apk&csr=9dcc',
        //       appName: 'QQ',
        //       pkgName: 'com.tencent.mobileqq',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_6633_1637171528/96',
        //       appDownCount: '\t\t下载95亿次\n\t'
        //     },
        //     {
        //       apkMd5: 'ECBC26B82A88E949BCBBA59A9D3FC30D',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/ECBC26B82A88E949BCBBA59A9D3FC30D.apk?fsname=com.tencent.mm_8.0.16_2040.apk&csr=9dcc',
        //       appName: '微信',
        //       pkgName: 'com.tencent.mm',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10910_1635498550/96',
        //       appDownCount: '\t\t下载88亿次\n\t'
        //     },
        //     {
        //       apkMd5: '66622D0D4EA7529E929E15E20639D918',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/66622D0D4EA7529E929E15E20639D918.apk?fsname=com.qzone_8.8.0.288_137.apk&csr=9dcc',
        //       appName: 'QQ空间',
        //       pkgName: 'com.qzone',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_9959_1636980723/96',
        //       appDownCount: '\t\t下载15亿次\n\t'
        //     },
        //     {
        //       apkMd5: 'D8478038CEFAD94669243155E9FD9988',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/D8478038CEFAD94669243155E9FD9988.apk?fsname=com.immomo.momo_9.1.4_8035.apk&csr=9dcc',
        //       appName: 'MOMO陌陌',
        //       pkgName: 'com.immomo.momo',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_11381_1637052068/96',
        //       appDownCount: '\t\t下载6.4亿次\n\t'
        //     },
        //     {
        //       apkMd5: '9FC4B8815B0D293CEF865F71EE8A2D63',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/9FC4B8815B0D293CEF865F71EE8A2D63.apk?fsname=com.p1.mobile.putong_4.9.7.1_2497110.apk&csr=9dcc',
        //       appName: '探探',
        //       pkgName: 'com.p1.mobile.putong',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10604320_1637118008/96',
        //       appDownCount: '\t\t下载1.6亿次\n\t'
        //     },
        //     {
        //       apkMd5: '7D690C091EEBBE85DDCBBF6888852DDC',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/7D690C091EEBBE85DDCBBF6888852DDC.apk?fsname=com.ifreetalk.ftalk_7.1.010_10701010.apk&csr=9dcc',
        //       appName: '派派',
        //       pkgName: 'com.ifreetalk.ftalk',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_1115820_1636725527/96',
        //       appDownCount: '\t\t下载1.0亿次\n\t'
        //     },
        //     {
        //       apkMd5: 'CC569C140E552FF72767A9DD937CF4D4',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/CC569C140E552FF72767A9DD937CF4D4.apk?fsname=com.m4399.gamecenter_6.3.0.50_1678.apk&csr=9dcc',
        //       appName: '4399游戏盒',
        //       pkgName: 'com.m4399.gamecenter',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_196230_1637198293/96',
        //       appDownCount: '\t\t下载1.9亿次\n\t'
        //     },
        //     {
        //       apkMd5: '464726C5AF8AECDE2E74D41BDAEA71F3',
        //       apkUrl: 'https://imtt.dd.qq.com/16891/apk/464726C5AF8AECDE2E74D41BDAEA71F3.apk?fsname=com.baidu.tieba_12.13.2.0_202179072.apk&csr=9dcc',
        //       appName: '百度贴吧',
        //       pkgName: 'com.baidu.tieba',
        //       iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_2753_1636524531/96',
        //       appDownCount: '\t\t下载1.7亿次\n\t'
        //     }
        //   ]
        // }
      ],
      union: [
        {
          contextId: 42,
          picUrl: 'http://img2.sj.qq.com/upload/2013/11/18/0ea72392a6c75d5a069dc32b60266dc6.jpg',
          appDetails: [
            {
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/881419F9137D97BD345C601AF0439BD3.apk?fsname=com.tencent.qqsports_6.6.31.991_991.apk&csr=3554',
              appName: '腾讯体育-中超英超直播',
              pkgName: 'com.tencent.qqsports',
              apkMd5: '881419F9137D97BD345C601AF0439BD3',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_1297151_1636507338/256'
            },
            {
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/6B374470C6C4C3E877DAD96B23158D3F.apk?fsname=com.u17.comic.phone_5.8.5_5800500.apk&csr=3554',
              appName: '有妖气漫画',
              pkgName: 'com.u17.comic.phone',
              apkMd5: '6B374470C6C4C3E877DAD96B23158D3F',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_207027_1635165727/256'
            },
            {
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/5F3F10E3C3EA06F0FADF977ABE6414A8.apk?fsname=com.dianping.v1_10.53.3_105301.apk&csr=3554',
              appName: '大众点评',
              pkgName: 'com.dianping.v1',
              apkMd5: '5F3F10E3C3EA06F0FADF977ABE6414A8',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_7960_1637050565/256'
            },
            {
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/3165B655F2DA15CAFE11A8881D4812D3.apk?fsname=com.yinhan.hunter.tx_556.apk&csr=3554',
              appName: '时空猎人-新角色',
              pkgName: 'com.yinhan.hunter.tx',
              apkMd5: '3165B655F2DA15CAFE11A8881D4812D3',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_1012592_1636949585/256'
            },
            // {
            //   apkUrl: 'https://imtt.dd.qq.com/16891/apk/04BA1D2E715C503A4281C1776B410A74.apk?fsname=com.yinhan.shenmo.tencent_3.3.35_222.apk&csr=3554',
            //   appName: '神魔2.0-下载送Q币',
            //   pkgName: 'com.yinhan.shenmo.tencent',
            //   apkMd5: '04BA1D2E715C503A4281C1776B410A74',
            //   iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10297682_1555079334/256'
            // },
            {
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/CA98D3A8A0203A98C610297954531F90.apk?fsname=com.tencent.JWX_102.apk&csr=3554',
              appName: '傲世西游',
              pkgName: 'com.tencent.JWX',
              apkMd5: 'CA98D3A8A0203A98C610297954531F90',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_1195255_1635478825/256'
            },
            {
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/D8478038CEFAD94669243155E9FD9988.apk?fsname=com.immomo.momo_9.1.4_8035.apk&csr=3554',
              appName: 'MOMO陌陌',
              pkgName: 'com.immomo.momo',
              apkMd5: 'D8478038CEFAD94669243155E9FD9988',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_11381_1637052068/256'
            },
            {
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/B1AC3281EBF17C090DD9A4285FA80D87.apk?fsname=com.duowan.mobile_8.2.2_112827.apk&csr=3554',
              appName: 'YY',
              pkgName: 'com.duowan.mobile',
              apkMd5: 'B1AC3281EBF17C090DD9A4285FA80D87',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_9652_1636529841/256'
            }
          ]
        },
        {
          contextId: 43,
          picUrl: 'http://img3.sj.qq.com/upload/2013/11/18/a14284a35f316957f0e8f43453c829d3.jpg',
          appDetails: [
            {
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/3473C4C397DFBB375385D4392461E1E5.apk?fsname=com.yoloho.dayima_8.4.2_540.apk&csr=3554',
              appName: '大姨妈月经期助手',
              pkgName: 'com.yoloho.dayima',
              apkMd5: '3473C4C397DFBB375385D4392461E1E5',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_5832_1636540483/256'
            },
            // {
            //   apkUrl: 'https://imtt.dd.qq.com/16891/apk/625369DD437EBACD6A4958A4F2E9FD45.apk?fsname=com.xikang.android.slimcoach_6.9.12_112.apk&csr=3554',
            //   appName: '瘦瘦-健康瘦身减肥顾问',
            //   pkgName: 'com.xikang.android.slimcoach',
            //   apkMd5: '625369DD437EBACD6A4958A4F2E9FD45',
            //   iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_1119040_1582253525/256'
            // },
            {
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/C6C416C53172837BE5C7E193D44B05D8.apk?fsname=com.lingan.seeyou_8.2.3_209.apk&csr=3554',
              appName: '美柚-大姨妈月经期助手',
              pkgName: 'com.lingan.seeyou',
              apkMd5: 'C6C416C53172837BE5C7E193D44B05D8',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_1248991_1634863465/256'
            },
            {
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/BDF5927A366C6C66C447F4A59C35F72E.apk?fsname=com.dailyyoga.cn_9.5.2.1_356.apk&csr=3554',
              appName: '每日瑜伽',
              pkgName: 'com.dailyyoga.cn',
              apkMd5: 'BDF5927A366C6C66C447F4A59C35F72E',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_208247_1637041347/256'
            },
            {
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/7E1CFAA296E82F166A7722F2CE472650.apk?fsname=com.changba_10.8.4.1_1084.apk&csr=3554',
              appName: '唱吧',
              pkgName: 'com.changba',
              apkMd5: '7E1CFAA296E82F166A7722F2CE472650',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_206678_1637118877/256'
            },
            {
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/4DEE2D407DB67FE466B70A1B59912E99.apk?fsname=com.huofar_7.1.8_75.apk&csr=3554',
              appName: '过日子',
              pkgName: 'com.huofar',
              apkMd5: '4DEE2D407DB67FE466B70A1B59912E99',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_242690_1636346980/256'
            },
            {
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/516F588065337211E841DBADB7342382.apk?fsname=com.xiachufang_8.1.1_692.apk&csr=3554',
              appName: '下厨房',
              pkgName: 'com.xiachufang',
              apkMd5: '516F588065337211E841DBADB7342382',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_5399_1636969964/256'
            },
            {
              apkUrl: 'https://imtt.dd.qq.com/16891/apk/5B505C3CC4E9C1EA570D305D906E8A84.apk?fsname=com.boohee.one_8.0.0_238.apk&csr=3554',
              appName: '薄荷健康',
              pkgName: 'com.boohee.one',
              apkMd5: '5B505C3CC4E9C1EA570D305D906E8A84',
              iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_1298168_1636685454/256'
            }
          ]
        },
        {
          contextId: 12,
          picUrl: 'http://img2.sj.qq.com/upload/2014/05/15/64420c6ce5215cbcacaf89c4ff3983c1.jpg',
          appDetails: []
        },
        {
          contextId: 200,
          picUrl: 'http://img3.sj.qq.com/upload/2014/05/30/78c94eb81460f1884d22effcdd4439b6.jpg',
          appDetails: []
        },
        {
          contextId: 191,
          picUrl: 'http://img2.sj.qq.com/upload/2014/05/15/0b655c0d7c73ca3f0ef4f7ec675c5999.jpg',
          appDetails: []
        }
      ],
      base: [
        {
          apkMd5: 'E0C7692C7264EBC38AA4F2B9FC5BAF11',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/E0C7692C7264EBC38AA4F2B9FC5BAF11.apk?fsname=ctrip.android.view_8.42.0_1449.apk&csr=9dcc',
          appName: '携程旅行-订酒店机票火车票',
          pkgName: 'ctrip.android.view',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_6240_1636958580/96'
        },
        {
          apkMd5: 'D2510450258BBA98E67CA99B44443A7B',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/D2510450258BBA98E67CA99B44443A7B.apk?fsname=com.tencent.mobileqq_8.8.50_2324.apk&csr=9dcc',
          appName: 'QQ',
          pkgName: 'com.tencent.mobileqq',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_6633_1637171528/96'
        },
        {
          apkMd5: 'ECBC26B82A88E949BCBBA59A9D3FC30D',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/ECBC26B82A88E949BCBBA59A9D3FC30D.apk?fsname=com.tencent.mm_8.0.16_2040.apk&csr=9dcc',
          appName: '微信',
          pkgName: 'com.tencent.mm',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10910_1635498550/96'
        },
        {
          apkMd5: '26F795F14A19EE36558DEEC7082A15F0',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/26F795F14A19EE36558DEEC7082A15F0.apk?fsname=com.snda.wifilocating_4.8.06_211117.apk&csr=9dcc',
          appName: 'WiFi万能钥匙',
          pkgName: 'com.snda.wifilocating',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_93301_1637155936/96'
        },
        {
          apkMd5: '5BFDDFD468EF820195B5CD9B52A90F57',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/5BFDDFD468EF820195B5CD9B52A90F57.apk?fsname=com.qiyi.video_12.11.0_800121150.apk&csr=9dcc',
          appName: '爱奇艺',
          pkgName: 'com.qiyi.video',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_7720_1636362705/96'
        },
        {
          apkMd5: '8ED8494B050E1F0F935F05CE3B8791C7',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/8ED8494B050E1F0F935F05CE3B8791C7.apk?fsname=com.qq.reader_7.6.9.888_209.apk&csr=9dcc',
          appName: 'QQ阅读-小说漫画电子书阅读器',
          pkgName: 'com.qq.reader',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10555_1636542750/96'
        },
        {
          apkMd5: '9E4AECECBCAC691D8F2B12D96C41ABE7',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/9E4AECECBCAC691D8F2B12D96C41ABE7.apk?fsname=com.tencent.weishi_8.46.0.588_932.apk&csr=9dcc',
          appName: '腾讯微视-短视频创作与分享',
          pkgName: 'com.tencent.weishi',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_10261931_1636968454/96'
        },
        {
          apkMd5: '9DB81E434251E00E9616510FB2624A99',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/9DB81E434251E00E9616510FB2624A99.apk?fsname=com.sohu.sohuvideo_9.1.01_9001001.apk&csr=9dcc',
          appName: '搜狐视频-电影电视剧美剧影音视频播放器',
          pkgName: 'com.sohu.sohuvideo',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_6429_1636338618/96'
        },
        // {
        //   apkMd5: 'C376ECF0E02A456A7E9DC5B72902587D',
        //   apkUrl: 'https://imtt.dd.qq.com/16891/apk/C376ECF0E02A456A7E9DC5B72902587D.apk?fsname=com.cyjh.gundam_3.5.9_359.apk&csr=9dcc',
        //   appName: '1104330607',
        //   pkgName: 'com.cyjh.gundam',
        //   iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_12043269_1592550217/96'
        // },
        {
          apkMd5: '963911FFA85921F9D64B5D25E16F5957',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/963911FFA85921F9D64B5D25E16F5957.apk?fsname=com.tencent.qqmusic_11.0.1.6_2520.apk&csr=9dcc',
          appName: 'QQ音乐',
          pkgName: 'com.tencent.qqmusic',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_6259_1636374590/96'
        },
        {
          apkMd5: 'F98C3D065361FEB10D156CCED6120733',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/F98C3D065361FEB10D156CCED6120733.apk?fsname=com.sohu.inputmethod.sogou_10.36.1_1541.apk&csr=9dcc',
          appName: '搜狗输入法',
          pkgName: 'com.sohu.inputmethod.sogou',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_6866_1637047319/96'
        },
        {
          apkMd5: '7694BF3FE1F1901A72FB66EA8B3646BA',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/7694BF3FE1F1901A72FB66EA8B3646BA.apk?fsname=com.moji.mjweather_9.0200.02_9020002.apk&csr=9dcc',
          appName: '墨迹天气',
          pkgName: 'com.moji.mjweather',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_9206_1637043683/96'
        },
        {
          apkMd5: 'F510D0377559A16E413D3AADB8C2541C',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/F510D0377559A16E413D3AADB8C2541C.apk?fsname=com.baidu.BaiduMap_15.10.5_1115.apk&csr=9dcc',
          appName: '百度地图',
          pkgName: 'com.baidu.BaiduMap',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_9997_1636967674/96'
        },
        {
          apkMd5: '18E580A1BA1D5417B5DD87E42A1B8B28',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/18E580A1BA1D5417B5DD87E42A1B8B28.apk?fsname=com.tencent.reading_7.4.0_7400.apk&csr=9dcc',
          appName: '快报',
          pkgName: 'com.tencent.reading',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_12082013_1637118528/96'
        },
        {
          apkMd5: '94172B59E2C3565BC3C11080B58A8FD4',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/94172B59E2C3565BC3C11080B58A8FD4.apk?fsname=cn.wps.moffice_eng_13.17.0_1230.apk&csr=9dcc',
          appName: 'WPS Office',
          pkgName: 'cn.wps.moffice_eng',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_134041_1636967254/96'
        },
        {
          apkMd5: '66622D0D4EA7529E929E15E20639D918',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/66622D0D4EA7529E929E15E20639D918.apk?fsname=com.qzone_8.8.0.288_137.apk&csr=9dcc',
          appName: 'QQ空间',
          pkgName: 'com.qzone',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_9959_1636980723/96'
        },
        {
          apkMd5: '2F5BC64CEE1618AE1C7978DA61F7DE68',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/2F5BC64CEE1618AE1C7978DA61F7DE68.apk?fsname=com.cubic.autohome_11.10.0_11100.apk&csr=9dcc',
          appName: '汽车之家',
          pkgName: 'com.cubic.autohome',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_4060_1637225857/96'
        },
        // {
        //   apkMd5: '8C9219CE5BBAD997CD4DAFE1B06C8939',
        //   apkUrl: 'https://imtt.dd.qq.com/16891/apk/8C9219CE5BBAD997CD4DAFE1B06C8939.apk?fsname=com.sdu.didi.psnger_6.2.4_2143.apk&csr=9dcc',
        //   appName: '滴滴出行',
        //   pkgName: 'com.sdu.didi.psnger',
        //   iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_288717_1624514350/96'
        // },
        {
          apkMd5: 'FCE3CF77F1F6AAD4BD330070157B2D5D',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/FCE3CF77F1F6AAD4BD330070157B2D5D.apk?fsname=com.moxiu.launcher_7.3.6_779.apk&csr=9dcc',
          appName: '魔秀桌面',
          pkgName: 'com.moxiu.launcher',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_1197236_1635410676/96'
        },
        {
          apkMd5: '0A9ADE6078CA14D3154726EB353561F1',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/0A9ADE6078CA14D3154726EB353561F1.apk?fsname=com.thestore.main_8.1.7_818.apk&csr=9dcc',
          appName: '1号会员店',
          pkgName: 'com.thestore.main',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_9797_1637152886/96'
        },
        {
          apkMd5: 'D0648D46973D0E2BD05B89A9FBEF63B8',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/D0648D46973D0E2BD05B89A9FBEF63B8.apk?fsname=com.baidu.searchbox_12.28.5.10_108025088.apk&csr=9dcc',
          appName: '百度',
          pkgName: 'com.baidu.searchbox',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_4859_1637134196/96'
        },
        {
          apkMd5: '8E33D5DB6D02A7518D5FFAACA06E802B',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/8E33D5DB6D02A7518D5FFAACA06E802B.apk?fsname=com.Qunar_10.0.20_253.apk&csr=9dcc',
          appName: '去哪儿旅行-酒店.火车',
          pkgName: 'com.Qunar',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_5091_1636628175/96'
        },
        {
          apkMd5: '5E25177A586B2C67746F5E73E37A5A7C',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/5E25177A586B2C67746F5E73E37A5A7C.apk?fsname=com.tencent.qqlive_8.4.90.26446_26446.apk&csr=9dcc',
          appName: '腾讯视频',
          pkgName: 'com.tencent.qqlive',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_3040_1637050420/96'
        },
        {
          apkMd5: '2F99A195DC1586F3372583BE58CA5965',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/2F99A195DC1586F3372583BE58CA5965.apk?fsname=com.autonavi.minimap_11.11.1.2843_111100.apk&csr=9dcc',
          appName: '高德地图',
          pkgName: 'com.autonavi.minimap',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_7678_1635848770/96'
        },
        {
          apkMd5: '3629D6B809A0BC66F3970317A32D4EA6',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/3629D6B809A0BC66F3970317A32D4EA6.apk?fsname=com.mogujie_15.9.1.24129_1591000.apk&csr=9dcc',
          appName: '蘑菇街',
          pkgName: 'com.mogujie',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_4846_1636958594/96'
        },
        {
          apkMd5: '1F4A5D9B13F051E1F7F8B1D1FFA3B131',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/1F4A5D9B13F051E1F7F8B1D1FFA3B131.apk?fsname=com.when.coco_7.5.0_8115.apk&csr=9dcc',
          appName: '365日历万年历农历',
          pkgName: 'com.when.coco',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_1278445_1634093019/96'
        },
        {
          apkMd5: '590B7BC0EA994D952B09A9A5283B82A6',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/590B7BC0EA994D952B09A9A5283B82A6.apk?fsname=com.achievo.vipshop_7.57.8_75708.apk&csr=9dcc',
          appName: '唯品会',
          pkgName: 'com.achievo.vipshop',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_8588_1637203390/96'
        },
        {
          apkMd5: '9FA682181F5DDE4EAEF8D5CACCF22E20',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/9FA682181F5DDE4EAEF8D5CACCF22E20.apk?fsname=com.meitu.meiyancamera_10.1.80_10180.apk&csr=9dcc',
          appName: 'BeautyCam美颜相机',
          pkgName: 'com.meitu.meiyancamera',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_1176832_1636632960/96'
        },
        {
          apkMd5: 'E538CC83C9E2D9DDBA2ED51FB3D90F18',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/E538CC83C9E2D9DDBA2ED51FB3D90F18.apk?fsname=com.smile.gifmaker_9.10.20.22696_22696.apk&csr=9dcc',
          appName: '快手',
          pkgName: 'com.smile.gifmaker',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_2608_1637044666/96'
        },
        {
          apkMd5: '251248A7F20293761F77261005BC0695',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/251248A7F20293761F77261005BC0695.apk?fsname=com.tongcheng.android_10.2.2.1_285.apk&csr=9dcc',
          appName: '同程旅行-再出发就同程',
          pkgName: 'com.tongcheng.android',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_4852_1636611769/96'
        },
        // {
        //   apkMd5: '440A00169607E4967194C2C28003E538',
        //   apkUrl: 'https://imtt.dd.qq.com/16891/apk/440A00169607E4967194C2C28003E538.apk?fsname=com.culiukeji.huanletao_3.39_155.apk&csr=9dcc',
        //   appName: '楚楚街',
        //   pkgName: 'com.culiukeji.huanletao',
        //   iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_1296221_1589009302/96'
        // },
        {
          apkMd5: '91A139C368FBA142D35DF6E105414743',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/91A139C368FBA142D35DF6E105414743.apk?fsname=com.xiudang.jiukuaiyou.ui_5.3.4_174.apk&csr=9dcc',
          appName: '卷皮-9.9包邮',
          pkgName: 'com.xiudang.jiukuaiyou.ui',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_123128_1609746061/96'
        },
        {
          apkMd5: '7105E43AFE0582BD87B45EAE558C483B',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/7105E43AFE0582BD87B45EAE558C483B.apk?fsname=com.tuan800.tao800_4.98.0_49800.apk&csr=9dcc',
          appName: '折800-独家折扣优惠买',
          pkgName: 'com.tuan800.tao800',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_187076_1635143482/96'
        },
        {
          apkMd5: '2A3711EA188DA4DFDB796F4E7467B1FA',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/2A3711EA188DA4DFDB796F4E7467B1FA.apk?fsname=com.cubic.choosecar_7.2.5_21111718.apk&csr=9dcc',
          appName: '汽车报价',
          pkgName: 'com.cubic.choosecar',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_1642_1637204436/96'
        },
        {
          apkMd5: '5E3C0FC221AE8C4C8317DA6AE2F77DB1',
          apkUrl: 'https://imtt.dd.qq.com/16891/apk/5E3C0FC221AE8C4C8317DA6AE2F77DB1.apk?fsname=com.gome.eshopnew_8.3.3_233.apk&csr=9dcc',
          appName: '真快乐',
          pkgName: 'com.gome.eshopnew',
          iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_243325_1636690337/96'
        }
        // {
        //   apkMd5: 'F9B33AC4E7351D2F4A5849869C1F8285',
        //   apkUrl: 'https://imtt.dd.qq.com/16891/apk/F9B33AC4E7351D2F4A5849869C1F8285.apk?fsname=com.tencent.movieticket_7.7.3_85.apk&csr=9dcc',
        //   appName: '娱票儿',
        //   pkgName: 'com.tencent.movieticket',
        //   iconUrl: 'https://pp.myapp.com/ma_icon/0/icon_95258_1555189919/96'
        // }
      ],
      cates: [
        [
          {
            cateId: '-10',
            cateName: '腾讯软件'
          },
          {
            cateId: '122',
            cateName: '购物'
          },
          {
            cateId: '102',
            cateName: '阅读'
          },
          {
            cateId: '110',
            cateName: '新闻'
          },
          {
            cateId: '103',
            cateName: '视频'
          },
          {
            cateId: '108',
            cateName: '旅游'
          },
          {
            cateId: '115',
            cateName: '工具'
          },
          {
            cateId: '106',
            cateName: '社交'
          },
          {
            cateId: '101',
            cateName: '音乐'
          },
          {
            cateId: '119',
            cateName: '美化'
          },
          {
            cateId: '104',
            cateName: '摄影'
          },
          {
            cateId: '114',
            cateName: '理财'
          },
          {
            cateId: '117',
            cateName: '系统'
          },
          {
            cateId: '107',
            cateName: '生活'
          },
          {
            cateId: '112',
            cateName: '出行'
          },
          {
            cateId: '118',
            cateName: '安全'
          },
          {
            cateId: '111',
            cateName: '教育'
          },
          {
            cateId: '109',
            cateName: '健康'
          },
          {
            cateId: '105',
            cateName: '娱乐'
          },
          {
            cateId: '100',
            cateName: '儿童'
          },
          {
            cateId: '113',
            cateName: '办公'
          },
          {
            cateId: '116',
            cateName: '通讯'
          }
        ],
        [
          {
            cateId: '147',
            cateName: '休闲益智'
          },
          {
            cateId: '121',
            cateName: '网络游戏'
          },
          {
            cateId: '149',
            cateName: '飞行射击'
          },
          {
            cateId: '144',
            cateName: '动作冒险'
          },
          {
            cateId: '151',
            cateName: '体育竞速'
          },
          {
            cateId: '148',
            cateName: '棋牌中心'
          },
          {
            cateId: '153',
            cateName: '经营策略'
          },
          {
            cateId: '146',
            cateName: '角色扮演'
          }
        ]
      ],
      assets: '',
      source: '',
      imgRand: [],
      baseUrl: ''
    };
  },
  methods: {
    getLinkUrl (item) {
      // if (+item.adType === 1) {
      //   return baseUrl + '/detail.htm?apkName=' + item.pkgNames[0] + '&info=' + item.appDetails[0].apkMd5;
      // } else if (+item.adType === 2) {
      //   return baseUrl + '/union.htm?unionId=' + item.contextId;
      // } else if (+item.adType === 3) {
      //   return item.toUrl;
      // }
      return 'https://a.app.qq.com/o/simple.jsp?pkgname=com.hicorenational.antifraud&g_f=1000047';
    },
    renderLiTag (item, index) {
      let tagStyle;
      if (+index === 0) {
        tagStyle = `z-index:2;background-image:url(${item.picUrl.replace('http://', 'https://')})`;
      } else {
        tagStyle = `z-index:-1; data-original="${item.picUrl.replace('http://', 'https://')}`;
      }
      return tagStyle;
    }
  },
  created () {
    if (window.location.href.indexOf('?mobile') < 0) {
      try {
        if (/Android|Windows Phone|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent)) {
          window.location.replace('https://cftweb.3g.qq.com/qqappstore/index');
        }
      } catch (e) {}
    };
    // 加载对应页面的css
    dynamicLoadCss('index');
    this.imgRand = onlineMap() || [];
    this.assets = sourceMap() ? sourceMap().assets : '';
    this.source = sourceMap() ? sourceMap().source : '';
    this.baseUrl = baseUrl;
  }
};
</script>

<style lang="less" scoped>

</style>
